import Gator from 'gator';
import mixitup from 'mixitup';

const HASH = location.hash.substr(1);
const ACTIVE_CLASS = 'faq-category--active';
const FAQ_MIX = document.querySelector('.faq-mix');

if (FAQ_MIX) {
    let placeholder = document.querySelector('.-js-label-target');
    let activeCategory;
    let timer;

    function activateElement(state, init = false) {
        if (activeCategory) {
            activeCategory.classList.remove(ACTIVE_CLASS);
        }
        if (state.activeSort.attribute && state.matching[0]) {
            activeCategory = state.matching[0];
            activeCategory.classList.add(ACTIVE_CLASS);

            if (init) {
                let element = document.querySelector('.faq-mixer__label input');
                setPlaceholderText(element);
            } else {
                history.pushState(null, null, `${location.pathname}#${state.activeSort.attribute}`);
            }
        } else {
            history.pushState(null, null, location.pathname);
        }
    }

    let mixer = mixitup(FAQ_MIX, {
        load: {
            filter: '.faq-category' + (HASH ? ',.faq-mixer__more' : ''),
            sort: HASH ? `${HASH}:desc` : 'default',
        },
        callbacks: {
            onMixEnd: (state) => {
                clearTimeout(timer);
                timer = setTimeout(() => {
                    activateElement(state);
                }, 100);
            },
        },
    });

    if (HASH) {
        activateElement(mixer.getState(), true);
    }

    Gator(document).on('keypress', "[role='button']", function (event) {
        if (event.charCode == 13) {
            // Enter
            this.click();
        }
    });

    function setPlaceholderText(element) {
        if (placeholder && element) {
            placeholder.textContent = element.dataset.label;
        }
    }

    if (placeholder) {
        let reset = document.querySelector('.-js-reset[name="faq-mixer__item"]');
        Gator(document).on('click', '.-js-label', function () {
            setPlaceholderText(this);

            // Close Dropdown on value change
            reset.click();
        });
    }

    [...document.querySelectorAll('.-js-reset[name]')].forEach((element) => {
        let active = false;

        Gator(element).on('click', function () {
            active = false;
        });

        Gator(document).on('click', `.-js-has-reset[name="${element.name}"]`, function () {
            if (active == this) {
                // Close Dropdown
                element.click();
                active = false;
            } else {
                // Open Dropdown
                active = this;
            }
        });
    });
}
